import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import * as moment from "moment";
import { Observable, Observer, Subscription } from "rxjs";
import { FeaturesBaseComponent } from "src/app/features-common/components/features-base.component";
//import { RetailerService } from '../retailers/retailer.service';
import { ComposeNewComponent } from "./compose-new/compose-new.component";
import { MessagesService } from "./messages.service";
import { ViewMessageComponent } from "./view-message/view-message.component";
import { Message } from "@stomp/stompjs";
import { JwtHelperService } from "@auth0/angular-jwt";
import { ComposeBulkComponent } from "./compose-bulk/compose-bulk.component";
import { Router } from "@angular/router";
const helper = new JwtHelperService();

@Component({
  selector: "app-messages",
  templateUrl: "./messages.component.html",
  styleUrls: ["./messages.component.scss"],
})
export class MessagesComponent
  extends FeaturesBaseComponent
  implements OnInit, OnChanges, OnDestroy {
  @Input() receivedMessages;
  @Input() allrecipients;
  asyncTabs: Observable<any[]>;
  columnDefs: any[];
  gridApi: any;
  gridColumnApi: any;
  rowData: any;
  defaultColDef: any;
  columnApi: any;
  date: any = new Date();
  selectedRows: any;
  searchValue: any;
  showMultiAction: boolean = false;
  selectAll: boolean = false;
  isInboxActive: boolean = true;
  isSentActive: boolean;
  isDeletedActive: boolean;
  retailerDetails: any;
  userHeaderName: string;
  rowClassRules;
  private messageSubscription: Subscription;
  userRole: any;
  constructor(
    private dialog: MatDialog,
    private messagesService: MessagesService,
    private router: Router
  ) {
    super();
    const token: string = localStorage.getItem("accessToken");
    let decoded_token: any = helper.decodeToken(token);
    this.userRole = decoded_token.role;
    this.userHeaderName = "Sender Name";
    this.receivedMessages;
    this.defaultColDef = {
      editable: false,
      sortable: true,
      filter: false,
      resizable: true,
      pagination: true,
      paginationAutoPageSize: true,
    };
    this.setReceivedGrid(this.receivedMessages);
  }

  // event on compose button click
  onComposeNew() {
    // Open a mat dilog to compose message
    const dialogRef = this.dialog.open(ComposeNewComponent, {
      panelClass: "compose-box",
      minHeight: "400px",
      width: "50vw",
      data: this.allrecipients,
    });

    dialogRef.afterClosed().subscribe(() => {
      this.gridApi.refreshCells();
    });
  }

  //event On Inbox button click
  onClickInbox(e: any) {
    this.isInboxActive = true;
    this.isSentActive = !this.isInboxActive;
    this.isDeletedActive = !this.isInboxActive;
    this.userHeaderName = "Sender Name";
    // clear grid selections
    this.gridApi.deselectAll();
    this.selectAll = false;
    // call api & set rowData
    this.messagesService
      .getReceivedMessages()
      .subscribe((res) =>
        res["httpcode"] == 200 ? this.setReceivedGrid(res["data"]) : []
      );
  }

  // event on Sent items button click
  onClickSent(e: any) {
    this.isSentActive = true;
    this.isInboxActive = !this.isSentActive;
    this.isDeletedActive = !this.isSentActive;
    this.userHeaderName = "Receiver name";

    // clear grid selections
    this.gridApi.deselectAll();
    this.selectAll = false;
    // call api & set rowData
    this.messagesService
      .getSentMessages()
      .subscribe((res) =>
        res["httpcode"] == 200 ? this.setSentGrid(res["data"]) : []
      );
  }

  //event on Deleted items button click
  onClickDeleted(e: any) {
    this.isDeletedActive = true;
    this.isInboxActive = !this.isDeletedActive;

    this.isSentActive = !this.isDeletedActive;
    this.userHeaderName = "Receiver name";
    // clear grid selections
    this.gridApi.deselectAll();
    this.selectAll = false;
    // call api & set rowData
    this.messagesService
      .getDeletedMessages()
      .subscribe((res) =>
        res["httpcode"] == 200 ? this.setDeletedGrid(res["data"]) : []
      );
  }

  onClickBulkSend() {
    const dialogRef = this.dialog.open(ComposeBulkComponent, {
      panelClass: "compose-box",
      minHeight: "400px",
      width: "50vw",
    });

    dialogRef.afterClosed().subscribe(() => {
      this.gridApi.refreshCells();
    });

  }

  setReceivedGrid(rowData) {
    const self = this;
    this.rowData = rowData;

    this.columnDefs = [
      { field: "", headerName: "", width: 40, checkboxSelection: true },
      {
        field: "importantFlag",
        headerName: "Flag",
        width: 130,
        cellRenderer: (data) => {
          return `<i style="color: gold" class="mi ${data.value == "No" || data.value == null
              ? "mi-star-border"
              : "mi-star"
            } star-icon"></i>`;
        },
        onCellClicked: (params) => self.handleFlagMessage(params.data),
      },
      {
        field: "sentByUserId",
        headerName: this.userHeaderName,
        width: 220,
        cellRenderer: (res) => {
          // return  res.value;
          let userName: any = this.allrecipients.find((x) => x.userId == res.value)?.displayName;
          return userName && userName ? userName : '';
        },
      },
      {
        field: "subject",
        headerName: "Subject",
        width: 140,
      },
      {
        field: "message",
        headerName: "Message",
        width: 330,
        cellRenderer: (data) => {
          return `<span class="mb-0">${data.value} </span>`;
        },
        onCellClicked: function (params) {
          self.handleViewMessage(params.data);
        },
      },
      {
        field: "messageFilePath",
        headerName: "",
        width: 20,
        cellRenderer: (res) => {
          return res.value && res.value
            ? `<span class="mi mi-attachment"></span>`
            : ``;
        },
        onCellClicked: function (params) {
          self.handleAttachment(params.data);
        },
      },
      {
        field: "createdDttm",
        headerName: "Received On",
        width: 200,
        sort: "desc",
        cellRenderer: (data) => {
          return `<div class="d-inline-block text-center">${moment(data.value).format("DD") === this.date.getDate().toString()
              ? moment(data.value).format("hh:mm:ss:a")
              : moment(data.value).format("ll")
            }</div>`;
        },
      },
      {
        field: "messageRecipientId",
        headerName: "",
        hide: true,
        cellRenderer: (data) => {
          return data.value;
        },
      },
    ];
    this.rowClassRules = {
      'read-rows': function (params) {
        console.log((params.data.readStatus === 'UnRead'));
        return (params.data.readStatus === 'UnRead')
      },
    };
  }

  setSentGrid(rowData) {
    const self = this;
    this.rowData = rowData;

    this.columnDefs = [
      { field: "", headerName: "", width: 40, checkboxSelection: true },
      {
        field: "importantFlag",
        headerName: "Flag",
        width: 130,
        cellRenderer: (data) => {
          return `<i style="color: gold" class="mi ${data.value == "No" || data.value == null
              ? "mi-star-border"
              : "mi-star "
            } star-icon"></i>`;
        },
        onCellClicked: (params) => self.handleFlagMessage(params.data),
      },
      {
        field: "messageId",
        headerName: this.userHeaderName,
        width: 220,
        cellRenderer: (res) => {
          let filteredRecipients: any = [];
          res.data.messageRecipients.forEach((ele) => {
            filteredRecipients.push(ele.recipientId);
          });
          if (filteredRecipients.length == res.data.messageRecipients.length) {
            let _userNames = this.allrecipients.filter((x) =>
              filteredRecipients.includes(x.userId)
            );
            let userNames: any = [];
            _userNames.forEach((element) => {
              userNames.push(element.displayName);
            });
            if (_userNames.length == userNames.length) {

              return userNames.toString();
            }
            return this.allrecipients.filter(
              (x) => x.userId == res.data.sentByUserId
            )[0].displayName;
          }
        },
      },
      {
        field: "subject",
        headerName: "Subject",
        width: 140,
      },
      {
        field: "message",
        headerName: "Message",
        width: 330,
        cellRenderer: (data) => {
          return `<span class="mb-0">${data.value} </span>`;
        },
        onCellClicked: function (params) {
          self.handleViewMessage(params.data);
        },
      },
      {
        field: "messageFilePath",
        headerName: "",
        width: 20,
        cellRenderer: (res) => {
          return res.value && res.value
            ? `<span class="mi mi-attachment"></span>`
            : ``;
        },
        onCellClicked: function (params) {
          self.handleAttachment(params.data);
        },
      },
      {
        field: "createdDttm",
        headerName: "Sent on",
        width: 200,
        sort: "desc",
        cellRenderer: (data) => {
          return `<div class="d-inline-block text-center">${moment(data?.value).format("DD") === this.date.getDate().toString()
              ? moment(data?.value).format("hh:mm:ss:a")
              : moment(data?.value).format("ll")
            }</div>`;
        },
      },
      {
        field: "senderId",
        headerName: "",
        hide: true,
        cellRenderer: (data) => {
          return data.value;
        },
      },
    ];
  }

  handleFlagMessage(data) {

    this.messagesService.putMessageflag(data.messageId).subscribe((res) => {
      if (res["httpcode"] == 200) {
        this.gridApi.getSelectedRows()[0].importantFlag =
          data.importantFlag?.toLowerCase() == null ||
            data.importantFlag?.toLowerCase() == "no"
            ? "Yes"
            : "No";
        this.gridApi.refreshCells();
      }
    });
  }

  handleViewMessage(message) {
    this.showMultiAction = this.isDeletedActive
      ? !this.isDeletedActive
      : this.showMultiAction;

    // Open a mat dilog to compose message
    const dialogRef = this.dialog.open(ViewMessageComponent, {
      panelClass: "view-message",
      minHeight: "200px",
      maxHeight: "400px",
      width: "50vw",
      data: message,
    });
    dialogRef.afterClosed().subscribe(() => {
      console.log(this.selectedRows);
      
      this.messagesService.markMessageRead(this.selectedRows[0].messageRecipientId).subscribe(res => {
        if (res['httpcode'] ==200){
          let currentUrl = this.router.url;
          this.router.routeReuseStrategy.shouldReuseRoute = () => false;
          this.router.onSameUrlNavigation = 'reload';
          this.router.navigate([currentUrl]);
        }
      })
    });
  }

  setDeletedGrid(rowData) {
    const self = this;
    this.rowData = rowData;

    this.columnDefs = [
      {
        field: "message",
        headerName: "Message",
        width: 330,
        cellRenderer: (data) => {
          return `<span class="mb-0">${data.value} </span>`;
        },
        onCellClicked: function (params) {
          self.handleViewMessage(params.data);
        },
      },
      {
        field: "messageFilePath",
        headerName: "",
        width: 20,
        cellRenderer: (res) => {
          return res.value && res.value
            ? `<span class="mi mi-attachment"></span>`
            : ``;
        },
        onCellClicked: function (params) {
          self.handleAttachment(params.data);
        },
      },
      {
        field: "createdDttm",
        headerName: "Received On",
        width: 200,
        sort: "desc",
        cellRenderer: (data) => {
          return `<div class="d-inline-block text-center">${moment(data?.value).format("DD") === this.date.getDate().toString()
              ? moment(data?.value).format("hh:mm:ss:a")
              : moment(data?.value).format("ll")
            }</div>`;
        },
      },
      {
        field: "messageId",
        headerName: "",
        hide: true,
        cellRenderer: (data) => {
          return data.value;
        },
      },
    ];
  }
  handleAttachment(data: any) {
    // action to show attachment

    window.open(data.messageFilePath);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  // event on row selection change
  onSelectionChanged(e) {
    this.selectedRows = this.gridApi.getSelectedRows();
    this.selectAll =
      this.gridApi.getDisplayedRowCount() === this.selectedRows.length
        ? true
        : false;
    this.showMultiAction = this.selectedRows.length > 0 ? true : false;
  }

  // event on all row chekbox selection
  onSelectAll(e) {
    if (e) {
      this.gridApi.selectAll();
    } else {
      this.gridApi.deselectAll();
    }
  }

  // event on delete actin button click
  onDelete() {

    // check if row selection is true
    if (this.selectedRows.length > 0) {
      if (this.isInboxActive) {
        let messageRecipientIds: any = [];
        this.selectedRows.forEach((element) => {
          messageRecipientIds.push(element.messageRecipientId);
          if (messageRecipientIds.length == this.selectedRows.length) {
            this.messagesService
              .deleteReceivedMessages(messageRecipientIds)
              .subscribe((res) =>
                res["httpcode"] == 200
                  ? this.onClickInbox("")
                  : this.onClickInbox("")
              );
          }
        });
        return;
      }
      if (this.isSentActive) {
        let messageIds: any = [];
        this.selectedRows.forEach((element) => {
          messageIds.push(element.messageId);
          if (messageIds.length == this.selectedRows.length) {
            this.messagesService
              .deleteSentMessages(messageIds)
              .subscribe((res) =>
                res["httpcode"] == 200
                  ? this.onClickSent("")
                  : this.onClickSent("")
              );
          }
        });
        return;
      }
      //  TODO: call api to perform delete action
      this.gridApi.refreshCells();
    }
  }

  // On global search input value
  quickSearch() {
    this.gridApi.setQuickFilter(this.searchValue);
  }

  ngOnInit(): void {
    super.ngOnInit();
    let token = localStorage.getItem("accessToken");
    if (token !== null && token != undefined) {
      const decodedToken = helper.decodeToken(token);
      const userId = decodedToken.user_id;
      this.rxStompService.activate();
      this.messageSubscription = this.rxStompService
        .watch(`/user/${userId}/subscribe`)
        .subscribe((message: Message) => {
          if (this.isInboxActive) {
            this.onClickInbox(null)
          }
        });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["receivedMessages"]) {
      this.receivedMessages = changes["receivedMessages"].currentValue;
      this.setReceivedGrid(this.receivedMessages);
    }
    if (changes["allrecipients"]) {
      this.allrecipients = changes["allrecipients"].currentValue;
      this.allrecipients.forEach(element => {
        if (element.role == "Retailer") {
          element.dropdownname = element.displayName + ' | ' + element.role + ' | ' + element.businessName;
        } else {
          element.dropdownname = element.displayName + ' | ' + element.role;
        }
      });

    }
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.messageSubscription.unsubscribe();
  }
}
